// extracted by mini-css-extract-plugin
module.exports = {"content":"ChangePasswordForm_content__2r7eD","resetPasswordButton":"ChangePasswordForm_resetPasswordButton__181YB"};